import { useEffect, useState } from "react";
import Icon from "@/components/Icon";
import { createLead } from "@/lib/api";

const EMPTY = { name: "", email: "", organization: "", phone: "", message: "" };

export default function ContactPage() {
  const [form, setForm] = useState(EMPTY);
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState("");

  useEffect(() => { document.title = "Contact | Proactive UMS Corporate"; window.scrollTo(0, 0); }, []);

  const update = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!form.name.trim() || !form.email.trim()) { setError("Please provide your name and email."); return; }
    setStatus("loading");
    try {
      await createLead({ ...form, type: "contact" });
      setStatus("success");
    } catch (err) {
      setStatus("error");
      const d = err?.response?.data?.detail;
      setError(typeof d === "string" ? d : "Something went wrong. Please try again.");
    }
  };

  return (
    <div className="ip" data-testid="contact-page">
      <section className="dp-hero ip-hero">
        <div className="dp-hero__bg" style={{ backgroundImage: "url(/assets/hero-slide-1.png)" }} />
        <div className="dp-hero__veil" />
        <div className="container">
          <div className="dp-hero__inner">
            <span className="eyebrow">Contact Proactive UMS</span>
            <h1 className="dp-hero__title display">Let’s Talk</h1>
            <p className="dp-hero__tagline">Care Forward. Always Proactive.</p>
            <p className="dp-hero__blurb">Tell us about your goals and our team will reach out to build a healthier tomorrow with you.</p>
          </div>
        </div>
      </section>

      <section className="contact-sec">
        <div className="container contact-grid">
          <div className="contact-form-wrap">
            {status === "success" ? (
              <div className="contact-success" data-testid="contact-success">
                <span className="modal__success-ic"><Icon name="Heart" size={30} /></span>
                <h3>Thank you, {form.name.split(" ")[0] || "friend"}!</h3>
                <p>Your message has been received. A member of the Proactive UMS team will be in touch shortly.</p>
              </div>
            ) : (
              <form className="cform" onSubmit={submit}>
                <h2 className="contact-form-title">Send us a message</h2>
                <div className="cform__row">
                  <label><span>Full Name<i>*</i></span><input value={form.name} onChange={update("name")} placeholder="Jane Doe" data-testid="contact-name" /></label>
                  <label><span>Work Email<i>*</i></span><input type="email" value={form.email} onChange={update("email")} placeholder="jane@organization.com" data-testid="contact-email" /></label>
                </div>
                <div className="cform__row">
                  <label><span>Organization</span><input value={form.organization} onChange={update("organization")} placeholder="Company / Health System" data-testid="contact-org" /></label>
                  <label><span>Phone</span><input value={form.phone} onChange={update("phone")} placeholder="(555) 000-0000" data-testid="contact-phone" /></label>
                </div>
                <label className="cform__full"><span>Message</span><textarea rows={5} value={form.message} onChange={update("message")} placeholder="How can we help?" data-testid="contact-message" /></label>
                {error && <p className="modal__error" data-testid="contact-error">{error}</p>}
                <button type="submit" className="btn btn--green" disabled={status === "loading"} data-testid="contact-submit">
                  {status === "loading" ? "Sending…" : "Send Message"} {status !== "loading" && <Icon name="ArrowRight" size={16} />}
                </button>
              </form>
            )}
          </div>

          <aside className="contact-info">
            <h3>Get in touch</h3>
            <div className="contact-info__item"><span className="contact-info__ic"><Icon name="Mail" size={18} /></span><div><strong>Email</strong><span>connect@proactiveums.com</span></div></div>
            <div className="contact-info__item"><span className="contact-info__ic"><Icon name="Phone" size={18} /></span><div><strong>Phone</strong><span>(555) 010-2024</span></div></div>
            <div className="contact-info__item"><span className="contact-info__ic"><Icon name="Building2" size={18} /></span><div><strong>Corporate</strong><span>Proactive UMS Corporate · United States</span></div></div>
            <div className="contact-info__social">
              <a href="#" aria-label="LinkedIn"><Icon name="Linkedin" size={16} /></a>
              <a href="#" aria-label="YouTube"><Icon name="Youtube" size={16} /></a>
              <a href="#" aria-label="X"><Icon name="Twitter" size={16} /></a>
              <a href="#" aria-label="Instagram"><Icon name="Instagram" size={16} /></a>
            </div>
          </aside>
        </div>
      </section>
    </div>
  );
}
